import { cn } from "@/lib/utils";
import Lottie from "lottie-react";
import loaderAnimation from "@/assets/lottieAnimations/Compi Empty.json";
import { SqButton } from "@/components/squircle-ui/button";
import { RiAddLine, RiDeleteBinLine } from "@remixicon/react";

const NoAds = ({
  className,
  hasFiltersApplied,
  onResetFilters,
  onAddBrand,
}: {
  className?: string;
  hasFiltersApplied: boolean;
  onResetFilters?: () => void;
  onAddBrand?: () => void;
}) => {
  return (
    <div className="flex flex-col gap-4 items-center justify-center h-full w-full">
      <div className={cn("w-[188px]", className)}>
        <Lottie
          animationData={loaderAnimation}
          loop={true}
          autoplay={true}
          style={{ width: "100%", height: "100%" }}
        />
      </div>
      <div className="flex flex-col items-center gap-[14px]">
        <div className="text-center">
          {hasFiltersApplied ? (
            <>
              <p className="overflow-hidden text-brand-primary-new text-center text-ellipsis text-[13px] font-medium leading-[19.157px] tracking-[0.26px]">
                Filters returned 0 results
              </p>
              <p className="overflow-hidden text-brand-primary-600 text-center text-ellipsis text-[12px] font-normal leading-[16px] tracking-[0.24px]">
                Tweak a filter or reset all to browse ads.
              </p>
            </>
          ) : (
            <>
              <p className="overflow-hidden text-brand-primary-new text-center text-ellipsis text-[13px] font-medium leading-[19.157px] tracking-[0.26px]">
                No ads available
              </p>
              <p className="overflow-hidden text-brand-primary-600 text-center text-ellipsis text-[12px] font-normal leading-[16px] tracking-[0.24px]">
                There aren't any ads to show right now, try different brands or <br />{" "}
                check back later.
              </p>
            </>
          )}
        </div>
        <div>
          {hasFiltersApplied ? (
            <SqButton variant="outline" size={"sm"} onClick={onResetFilters}>
              <RiDeleteBinLine size={14} className="text-brand-primary-400 shrink-0" />
              <p className="text-[11px] mt-[1px]">Reset all filters</p>
            </SqButton>
          ) : (
            <SqButton variant="outline" size={"sm"} onClick={onAddBrand}>
              <RiAddLine size={14} className="text-brand-primary-400 shrink-0" />
              <p className="text-[11px] mt-[1px]">Add brand</p>
            </SqButton>
          )}
        </div>
      </div>
    </div>
  );
};

export default NoAds;
